import LegalPage from "@/components/LegalPage";

const DEFAULT_BODY = (
  <>
    <p className="text-oc-textSecondary"><em>Laatst bijgewerkt: januari 2026 — Webtron BV</em></p>

    <h2>1. Verwerkingsverantwoordelijke</h2>
    <p>Webtron BV, A. Rodenbachwijk 12, 9792 Waregem, België. BTW BE0793944703. Contact: <a href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>.</p>

    <h2>2. Welke gegevens verzamelen we?</h2>
    <ul>
      <li>Naam en e-mailadres voor het verzenden van het rapport en facturen</li>
      <li>Telefoonnummer (optioneel)</li>
      <li>De inhoud van de offerte die je uploadt of intypt</li>
      <li>Betaalgegevens (verwerkt door MultiSafepay; we ontvangen enkel een transactiestatus)</li>
      <li>Technische logs (IP-adres, browser, datum) voor beveiliging</li>
    </ul>

    <h2>3. Doel van verwerking</h2>
    <p>Dienstverlening (analyse en rapport), facturatie, support, en wettelijke verplichtingen.</p>

    <h2>4. Rechtsgrond</h2>
    <p>Uitvoering van de overeenkomst, jouw uitdrukkelijke toestemming (GDPR-checkbox) en wettelijke verplichtingen voor facturatie.</p>

    <h2>5. Bewaartermijnen</h2>
    <ul>
      <li>Offertedocumenten + analyseresultaten: <strong>30 dagen</strong>, daarna automatisch en permanent verwijderd</li>
      <li>Betalingsgegevens: 7 jaar (wettelijke boekhoudplicht)</li>
      <li>E-mailadres voor support: tot 90 dagen na verwijderingsverzoek</li>
    </ul>

    <h2>6. Derde partijen</h2>
    <ul>
      <li><strong>Anthropic (Claude AI)</strong> — verwerkt de inhoud van je offerte voor analyse, gebonden aan een DPA</li>
      <li><strong>MultiSafepay</strong> — verwerkt betalingen, gevestigd in Nederland (EU)</li>
      <li><strong>Hostingprovider</strong> — voor het draaien van het platform binnen de EER</li>
    </ul>

    <h2>7. Jouw rechten</h2>
    <p>Inzage, correctie, verwijdering, bezwaar, overdraagbaarheid en intrekking van toestemming. Stuur een mail naar <a href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>. Je kan ook klacht indienen bij de Gegevensbeschermingsautoriteit (GBA).</p>

    <h2>8. Cookies</h2>
    <p>Zie ons <a href="/cookiebeleid">Cookiebeleid</a>.</p>

    <h2>9. Beveiliging</h2>
    <p>Alle communicatie verloopt via HTTPS. Bestanden worden opgeslagen met AES-256 encryptie. Toegang is strikt beperkt tot geautoriseerde medewerkers van Webtron BV.</p>
  </>
);

export default function Privacy() {
  return <LegalPage slug="privacy" defaultTitle="Privacybeleid" defaultBody={DEFAULT_BODY} />;
}
